import React, { useState, useEffect, useCallback, useRef } from 'react';
import { ResourceNode, SchedulerEvent } from '../../types';
import { Scheduler } from '.';
import { DateRangePicker } from 'rsuite';
import { dropDownActiveInActive, getValueFromResource, normalizeDateFormat } from '../../common/timeLiveFunction';
import { CloseTimeOffConfirmationModal, GetAccountEmployeeProjectEvents, GetAccountEmployeeScheduler, GetAccountProjectEmployeeEvents, GetAccountProjectSchedulerWithMilestone, GetEmployeeSchedulerCapacity, GetPermissionOfSchedule, RefreshScheduler, ShowAssignmentModal, UpdateAccountProjectMilestone, UpdateEmployeeSchedulerCapacity, updateMilestonePermissions, UpdateMonthDate, UpdateSchedulerMonth, UpdateShowMilestone, updateTabs, UpdateToShowModal, UpdateToShowProjectsModal } from './SchedulerSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import moment from 'moment';
import { normalizeProject, normalizeEmployee, normalizeEvent, countWorkingDays, normalizeTeamEmployees, normalizeProjectEvent } from '../utils/dataAdapter';
import AddEmployeeModal from './AddEmployeeModal';
import AssignTask from './AssignTask';
import AddUpdateMilestoneModal from './AddUpdateMilestoneModal';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import fetchTimeliveAPI from '../../common/fetchTimeliveAPI';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import AddProjectModal from './AddProjectModal';
import TimeOffConfirmationModal from './TimeOffConfirmationModalProps ';
import Loader from '../../common/Loader';
import { addMonths, subDays } from 'date-fns';
import { ShowToast } from '../../common/Toastr';
import { getCustomPagePermissionsAsync, getPagePermissionsAsync } from '../../common/GlobalSlice';
import { useLocation, useNavigate } from 'react-router-dom';

const getOneMonthRange = (start: Date) => {
  return {
    start,
    end: subDays(addMonths(start, 1), 1),
  };
};

const SchedulerMain = () => {
  const { isOpenModal, showAssignment, showMilestone, refreshData, tabs, isOpenProjectModal, timeOffConfirmation, loading, IsAdd, IsDelete, IsEdit, IsList, milestonePermissionsValues } = useAppSelector((state) => state.scheduler);
  const { maxMenuHeight, CurrentCultureDateFormat, pageId, menuList } = useAppSelector((state) => state.globalState);
  const initialStart = new Date();
  const fetchIdRef = useRef(0);
  const isFetchingRef = useRef(false);
  const { end: initialEnd } = getOneMonthRange(initialStart);
  const [isPermissionLoaded, setIsPermissionLoaded] = useState(false);
  const [resources, setResources] = useState<ResourceNode[]>([]);
  const [events, setEvents] = useState<SchedulerEvent[]>([]);
  const [activeTab, setActiveTab] = useState<"resource" | "team">("resource");
  const [SelectedStartDate, setSelectedStartDate] = useState<Date>(initialStart);
  const [SelectedEndDate, setSelectedEndDate] = useState<Date>(initialEnd);
  const [milestoneData, setMilestoneData] = useState({});
  const [milestoneClickedDate, setMilestoneClickedDate] = useState<Date | null>(null);
  const [capacityOptions, setCapacityoptions] = useState<any>([]);
  const [selectedCapacity, setSelectedCapacity] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingCounter, setLoadingCounter] = useState(0);
  const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
  const AccountId = localStorage.getItem('accountId');
  const [search, setSearch] = useState('');
  document.title = `Schedule | Livetecs`;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [loadedProjectIds, setLoadedProjectIds] = useState<Set<string>>(new Set());
  const [projectPageNo, setProjectPageNo] = useState(1);
  const [employeePageNo, setEmployeePageNo] = useState(1);
  const [hasMoreProjects, setHasMoreProjects] = useState(true);
  const [hasMoreEmployees, setHasMoreEmployees] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [searchDebounceTimer, setSearchDebounceTimer] = useState<any>(null);
  const [schedulePagePermission, setSchedulePagePermission]=useState<any>();
    const [milestonePermission, setMilestonePermission] = useState<any>();
  const [showProjectTab, setShowProjectTab] = useState(false);
  const startLoading = () => setLoadingCounter(prev => prev + 1);
  const stopLoading = () => setLoadingCounter(prev => Math.max(0, prev - 1));
  const navigate = useNavigate();

  const scrollToTop = () => {
    const timelineContainer = document.getElementById('timeline-scroll-container');
    const treeContainer = document.querySelector('.flex-grow-1[ref]') as HTMLDivElement;

    if (timelineContainer) {
      timelineContainer.scrollTop = 0;
      timelineContainer.scrollLeft = 0;
    }
    if (treeContainer) {
      treeContainer.scrollTop = 0;
    }
  };

  // useEffect(()=>{
  //   dispatch(GetPermissionOfSchedule(pageId))
  // },[dispatch, pageId, tabs])
  const getPagePermission = async () => {
    try {
      const response = await fetchTimeliveAPI('api/Permission/GetAccountPageDataPermissions/509', 'GET', "", true);
      const json = await response.json();
      if (json?.StatusCode === '200') {
        const data = json?.Data[0];
        const ListCheckboxesValues = data?.ShowMyDataForList && !data?.ShowMyProjectsDataForList && !data?.ShowAllDataForList;
        setShowProjectTab(ListCheckboxesValues);
        if (ListCheckboxesValues) {
          dispatch(updateTabs('team'));
          setActiveTab('team');
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    const initializePage = async () => {
      startLoading();
      try {
        dispatch(GetPermissionOfSchedule(pageId));
        const response = await dispatch(getCustomPagePermissionsAsync("30"));
        if (response?.payload?.length > 0) {
          // console.log(response?.payload, "response")
          const permissions = response?.payload[0];
          setMilestonePermission(permissions);
          dispatch(updateMilestonePermissions(permissions));
        }
      } catch (error) {
        console.error("Error loading permissions:", error);
      } finally {
        setIsPermissionLoaded(true);
        stopLoading();
      }
    };

    initializePage();
    getPagePermission();
  }, [dispatch, pageId]);

  const getProjectsAndClients = useCallback(async (pageNo = 1, append = false, searchText = '') => {
    if (!isPermissionLoaded) return;
    if (isFetchingRef.current) return;

    const requestId = ++fetchIdRef.current;
    isFetchingRef.current = true;
    startLoading();
    if (!append) {
      dispatch(UpdateMonthDate({ StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'), EndDate: moment(SelectedEndDate).format('YYYY-MM-DD') }))
    }
    const payload = {
      StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
      EndDate: moment(SelectedEndDate).format('YYYY-MM-DD'),
      pageNo: pageNo,
      pageSize: 10,
      searchText: searchText
    };

    try {
      if (append) {
        setIsLoadingMore(true);
      }
      setIsLoading(true)
      const result = await dispatch(GetAccountProjectSchedulerWithMilestone(payload));
      if (requestId !== fetchIdRef.current) return;
      if (result.payload) {
        const rawProjects = result.payload;

        if (rawProjects.length === 0) {
          setHasMoreProjects(false);
          if (append) {
            setIsLoadingMore(false);
          }
          return;
        }

        let allEvents: SchedulerEvent[] = [];
        let loadedIds = new Set<string>();

        const employeePromises = rawProjects.map((p: any) => {
          const obj = {
            AccountProjectId: p.AccountProjectId,
            StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
            EndDate: moment(SelectedEndDate).format('YYYY-MM-DD')
          }
          return dispatch(GetAccountProjectEmployeeEvents(obj));
        });

        const employeeResults = await Promise.all(employeePromises);
        if (requestId !== fetchIdRef.current) return;
        const fullResources = rawProjects.map((p: any, index: number) => {
          const pId = String(p.AccountProjectId);
          const projectNode = normalizeProject(p);

          // Add milestone events
          if (p.MilestoneEventsList) {
         if (milestonePermissionsValues?.IsList === true) {
              p.MilestoneEventsList.forEach((m: any) => {
                allEvents.push(normalizeEvent(m, pId, 'milestone'));
              });
            }
          }

          // Add project events
          if (p.ProjectEventsList) {
            p.ProjectEventsList.forEach((evt: any) => {
              allEvents.push(normalizeEvent(evt, pId, 'project'));
            });
          }

          const empResponse = employeeResults[index];

          if (empResponse?.payload) {
            const apiEmployees = empResponse.payload;
            const employeeNodes = apiEmployees.map((e: any) => normalizeEmployee(e, projectNode));
            projectNode.children = employeeNodes;

            apiEmployees.forEach((e: any) => {
              // Add task events
              if (e.EventsList && e.EventsList.length > 0) {
                e.EventsList.forEach((evt: any) => {
                  if (e.AccountEmployeeId == evt.AccountEmployeeId) {
                    allEvents.push(normalizeEvent(evt, String(e.AccountEmployeeId), 'task', e?.HoursPerDay));
                  }
                });
              }

              // Add time off events
              if (e.TimeOffEventsList && e.TimeOffEventsList.length > 0) {
                e.TimeOffEventsList.forEach((timeOffEvt: any) => {
                  const timeOffEvent = normalizeEvent(timeOffEvt, String(e.AccountEmployeeId), 'timeOff');
                  allEvents.push(timeOffEvent);
                });
              }
            });
          }

          loadedIds.add(pId);
          return projectNode;
        });
        if (append) {
          setResources(prev => {
            const existingIds = new Set(prev.map(r => r.id));
            const newUnique = fullResources.filter((r: any) => !existingIds.has(r.id));
            return [...prev, ...newUnique];
          });

          setEvents(prev => {
            const existingEventIds = new Set(prev.map(e => e.id));
            const newUniqueEvents = allEvents.filter(e => !existingEventIds.has(e.id));
            return [...prev, ...newUniqueEvents];
          });

          setLoadedProjectIds(prev => {
            const newSet = new Set(prev);
            loadedIds.forEach(id => newSet.add(id));
            return newSet;
          })
        } else {
          setResources(fullResources);
          setEvents(allEvents);
          setLoadedProjectIds(loadedIds);
        }
      }
    } catch (error) {
      console.error("Error fetching projects and employees:", error);
    } finally {
      stopLoading();
      isFetchingRef.current = false;
    }
  }, [SelectedStartDate, SelectedEndDate, dispatch, milestonePermissionsValues, isPermissionLoaded]);

  const getEmployeesForTeam = async (pageNo = 1, append = false, searchText = '') => {
    if (!isPermissionLoaded) return;
    if (isFetchingRef.current) return;

    const requestId = ++fetchIdRef.current;
    isFetchingRef.current = true;
    startLoading();
    try {
      const payload = {
        StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
        EndDate: moment(SelectedEndDate).format('YYYY-MM-DD'),
        pageNo: pageNo,
        pageSize: 10,
        searchText: searchText
      }
      setIsLoading(true);
      if (append) {
        setIsLoadingMore(true);
      }
      const response = await dispatch(GetAccountEmployeeScheduler(payload));
      if (requestId !== fetchIdRef.current) return;
      const result = response.payload;

      if (result?.length === 0) {
        setHasMoreEmployees(false);
        if (append) {
          setIsLoadingMore(false);
        }
        return;
      }

      if (result?.length > 0 && capacityOptions.length > 0) {
        const capacityId = result?.[0]?.SystemEmployeeSchedulerCapacityId;

        const selected =
          capacityId === 1 || capacityId === 0
            ? capacityOptions.find((opt: any) => opt.label === 'Daily')
            : capacityOptions.find((opt: any) => opt.label === 'Weekly');

        if (selected) {
          setSelectedCapacity(selected);
        }
      }
      if (result && result.length > 0) {
        let allEvents: any[] = [];
        let loadedIds = new Set<string>();

        const projectPromises = result.map((emp: any) => {
          const employeeId = emp?.AccountEmployeeId;
          const payload = {
            AccountEmployeeId: employeeId,
            StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
            EndDate: moment(SelectedEndDate).format('YYYY-MM-DD')
          }
          return dispatch(GetAccountEmployeeProjectEvents(payload));
        });

        const projectsResults = await Promise.all(projectPromises);
        if (requestId !== fetchIdRef.current) return;
        const teamEmployeesResource = result.map((team: any, index: any) => {
          const empId = String(team?.AccountEmployeeId);
          const employees = normalizeTeamEmployees(team);
          const projectResponse = projectsResults[index];

          if (team.EmployeeEventsList && team.EmployeeEventsList.length > 0) {
            team.EmployeeEventsList.forEach((evt: any) => {
              allEvents.push({
                id: `allocation-${empId}-${evt.StartDate}`,
                resourceId: empId,
                title: evt.AllocationSummary || '',
                start: new Date(evt.StartDate),
                end: new Date(evt.EndDate),
                color: evt.AllocationColor || '#8bc34a',
                TotalHours: evt?.TotalHours,
                percentage: team?.SystemEmployeeSchedulerCapacityId === 2,
                types: 'allocation',
                AccountEmployeeId: team.AccountEmployeeId,
                HoursOff: evt?.HoursOff
              });
            });
          }

          if (team.TimeOffEventsList && team.TimeOffEventsList.length > 0) {
            team.TimeOffEventsList.forEach((timeOffEvt: any) => {
              allEvents.push({
                id: `timeoff-emp-${empId}-${timeOffEvt.StartDate}-${timeOffEvt.TimeOffTypeId}`,
                resourceId: empId,
                title: timeOffEvt.TimeOffTypeName || 'Time Off',
                start: new Date(timeOffEvt.StartDate),
                end: new Date(timeOffEvt.EndDate),
                allocatedHours: null,
                allocationHoursPerDay: null,
                HoursPerDay: null,
                AccountEmployeeSchedulerId: null,
                AccountProjectTaskId: null,
                TimeOffTypeId: timeOffEvt.TimeOffTypeId,
                TimeOffTypeName: timeOffEvt.TimeOffTypeName,
                color: '#FAD1DF',
                types: 'timeOff',
                parentResourceId: empId
              });
            });
          }

          if (projectResponse?.payload && projectResponse.payload.length > 0) {
            const apiProject = projectResponse.payload;
            const projectNodes = apiProject.map((proj: any) => {
              const uniqueProjectId = `${empId}-${proj.AccountProjectId}`;
              const permissionFlag = proj?.ApplyAllProjectsForAdd ? proj?.ApplyAllProjectsForAdd : proj?.ApplyMyProjectsForAdd 
              const projectNode = {
                id: uniqueProjectId,//String(proj.AccountProjectId),
                name: proj.ProjectName,
                subtitle: proj.ClientName || '',
                type: 'teamProject',
                hasChildren: false,
                children: [],
                expanded: false,
                depth: 1,
                parentId: empId,
                ProjectId: String(proj.AccountProjectId),
                originalData: proj,
                HoursPerDay: proj?.HoursPerDay,
                TotalAllocatedHours: proj?.TotalAllocationHours,
                AccountProjectId: proj?.AccountProjectId,
                AccountEmployeeId: empId,
                permissionForAdd: permissionFlag
              };

              return projectNode;
            });

            employees.children = projectNodes;

            // Add project task events
            apiProject.forEach((proj: any) => {
              const uniqueProjectId = `${empId}-${proj.AccountProjectId}`;
              if (proj.EventsList && proj.EventsList.length > 0) {
                proj.EventsList.forEach((evt: any) => {
                  if (proj.AccountProjectId == evt.AccountProjectId) {
                    allEvents.push(normalizeProjectEvent(evt, uniqueProjectId, 'taskTeam', proj?.HoursPerDay, empId));
                  }
                });
              }

              if (proj.TimeOffEventsList && proj.TimeOffEventsList.length > 0) {
                proj.TimeOffEventsList.forEach((timeOffEvt: any) => {
                  allEvents.push({
                    id: `timeoff-project-${proj.AccountProjectId}-${timeOffEvt.StartDate}`,
                    resourceId: uniqueProjectId,//String(proj.AccountProjectId),
                    title: timeOffEvt.TimeOffTypeName || 'Project Time Off',
                    start: new Date(timeOffEvt.StartDate),
                    end: new Date(timeOffEvt.EndDate),
                    allocatedHours: null,
                    allocationHoursPerDay: null,
                    HoursPerDay: null,
                    AccountEmployeeSchedulerId: null,
                    AccountProjectTaskId: null,
                    TimeOffTypeId: timeOffEvt.TimeOffTypeId,
                    TimeOffTypeName: timeOffEvt.TimeOffTypeName,
                    color: '#FAD1DF',
                    types: 'timeOff',
                    parentResourceId: empId,
                    AccountEmployeeId: empId
                  });
                });
              }
            });
          } else {
            employees.children = [];
          }

          loadedIds.add(empId);
          return employees;
        });
        if (append) {
          setResources(prev => {
            const existingIds = new Set(prev.map(r => r.id));
            const newUnique = teamEmployeesResource.filter((r: any) => !existingIds.has(r.id));
            return [...prev, ...newUnique];
          });

          setEvents(prev => {
            const existingEventIds = new Set(prev.map(e => e.id));
            const newUniqueEvents = allEvents.filter(e => !existingEventIds.has(e.id));
            return [...prev, ...newUniqueEvents];
          });

          setLoadedProjectIds(prev => {
            const newSet = new Set(prev);
            loadedIds.forEach(id => newSet.add(id));
            return newSet;
          });
        } else {
          setResources(teamEmployeesResource);
          setEvents(allEvents);
          setLoadedProjectIds(loadedIds);
        }
      }
    } catch (error) {
      console.error("Error fetching team employees:", error);
    } finally {
      stopLoading();
      isFetchingRef.current = false;
    }
  }

  useEffect(() => {
    dispatch(updateTabs('resource'));
    setActiveTab('resource');
  }, []);

  useEffect(() => {
    if (!isPermissionLoaded) return;

    setProjectPageNo(1);
    setEmployeePageNo(1);
    setHasMoreProjects(true);
    setHasMoreEmployees(true);
    isFetchingRef.current = false;

    if (tabs === 'resource' && !showProjectTab) {
      if (SelectedStartDate && SelectedEndDate) {
        getProjectsAndClients(1, false);
        setActiveTab('resource');
      }
    } else {
      getEmployeesForTeam(1, false);
      setActiveTab('team')
    }
  }, [tabs, isPermissionLoaded, showProjectTab]);

  useEffect(() => {
    if (!isPermissionLoaded) return;

    if (tabs === 'resource' && !showProjectTab) {
      if (searchDebounceTimer) {
        clearTimeout(searchDebounceTimer);
      }

      const timer = setTimeout(() => {
        setProjectPageNo(1);
        setHasMoreProjects(true);
        isFetchingRef.current = false;
        getProjectsAndClients(1, false, search);
      }, 500);

      setSearchDebounceTimer(timer);

      return () => {
        if (timer) clearTimeout(timer);
      };
    } else if (tabs === 'team') {
      if (searchDebounceTimer) {
        clearTimeout(searchDebounceTimer);
      }

      const timer = setTimeout(() => {
        setEmployeePageNo(1);
        setHasMoreEmployees(true);
        isFetchingRef.current = false;
        getEmployeesForTeam(1, false, search);
      }, 500);

      setSearchDebounceTimer(timer);

      return () => {
        if (timer) clearTimeout(timer);
      };
    }
  }, [search, tabs, isPermissionLoaded]);

  useEffect(() => {
    if (!isPermissionLoaded) return;

    setProjectPageNo(1);
    setEmployeePageNo(1);
    setHasMoreProjects(true);
    setHasMoreEmployees(true);
    isFetchingRef.current = false;

    if (SelectedStartDate && SelectedEndDate && tabs === 'resource') {
      getProjectsAndClients(1, false);
    } else if (SelectedStartDate && SelectedEndDate && tabs === 'team') {
      getEmployeesForTeam(1, false);
    }
  }, [SelectedStartDate, SelectedEndDate, isPermissionLoaded]);

  const handleResourceExpand = async (resource: ResourceNode) => {
    if (loadedProjectIds.has(resource.id) && resource.children && resource.children.length > 0) {
      return;
    }
    if (resource.type === 'team') {
      try {
        const obj = {
          AccountEmployeeId: resource.id,
          StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
          EndDate: moment(SelectedEndDate).format('YYYY-MM-DD')
        };

        const response = await dispatch(GetAccountEmployeeProjectEvents(obj));

        if (response.payload && response.payload.length > 0) {
          const apiProjects = response.payload;
          const projectNodes = apiProjects.map((proj: any) => ({
            id: String(proj.AccountProjectId),
            name: proj.ProjectName,
            subtitle: proj.ClientName || '',
            type: 'teamProject',
            hasChildren: false,
            children: [],
            expanded: false,
            depth: 1,
            parentId: resource.id,
            ProjectId: String(proj.AccountProjectId),
            originalData: proj,
            HoursPerDay: proj?.HoursPerDay,
            TotalAllocatedHours: proj?.TotalAllocationHours,
            AccountProjectId: proj?.AccountProjectId
          }));

          const newEvents: SchedulerEvent[] = [];
          apiProjects.forEach((proj: any) => {
            if (proj.EventsList && proj.EventsList.length > 0) {
              proj.EventsList.forEach((evt: any) => {
                if (proj.AccountProjectId === evt.AccountProjectId) {
                  newEvents.push(
                    normalizeProjectEvent(
                      evt,
                      String(proj.AccountProjectId),
                      'taskTeam',
                      proj?.HoursPerDay
                    )
                  );
                }
              });
            }
          });

          setResources(prev =>
            prev.map(r => {
              if (r.id === resource.id) {
                return {
                  ...r,
                  children: projectNodes,
                  hasChildren: projectNodes.length > 0
                };
              }
              return r;
            })
          );
          setEvents(prev => [...prev, ...newEvents]);
          setLoadedProjectIds(prev => new Set(prev).add(resource.id));
        }
      } catch (error) {
        console.error("Failed to load employee projects:", error);
      }
      return;
    }

    if (resource.type === 'project') {
      try {
        const obj = {
          AccountProjectId: resource.id,
          StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
          EndDate: moment(SelectedEndDate).format('YYYY-MM-DD')
        };

        const response = await dispatch(GetAccountProjectEmployeeEvents(obj));

        if (response.payload && response.payload.length > 0) {
          const loadedEmployees = response.payload.map((e: any) =>
            normalizeEmployee(e, resource)
          );

          const newEvents: SchedulerEvent[] = [];
          response.payload.forEach((e: any) => {
            if (e.EventsList && e.EventsList.length > 0) {
              e.EventsList.forEach((evt: any) => {
                newEvents.push(
                  normalizeEvent(evt, String(e.AccountEmployeeId), 'task', e?.HoursPerDay)
                );
              });
            }
          });

          setResources(prev =>
            prev.map(r => {
              if (r.id === resource.id) {
                return {
                  ...r,
                  children: loadedEmployees
                };
              }
              return r;
            })
          );

          setEvents(prev => [...prev, ...newEvents]);
          setLoadedProjectIds(prev => new Set(prev).add(resource.id));
        }
      } catch (err) {
        console.error("Failed to load project employees:", err);
      }
    }
  };

  const refreshProjectData = useCallback(async (projectId: string) => {
    if (tabs === 'team') {
      setEmployeePageNo(1);
      setHasMoreEmployees(true);
      await getEmployeesForTeam(1, false);
    } else {
      try {
        setProjectPageNo(1);
        setHasMoreProjects(true)
        getProjectsAndClients(1, false);
        const obj = {
          AccountProjectId: projectId,
          StartDate: moment(SelectedStartDate).format('YYYY-MM-DD'),
          EndDate: moment(SelectedEndDate).format('YYYY-MM-DD')
        }
        const response = await dispatch(GetAccountProjectEmployeeEvents(obj));
        dispatch(RefreshScheduler(true))
        if (response.payload) {
          const loadedEmployees = response.payload.map((e: any) => {
            const parentResource = resources.find(r => r.id === projectId);
            return normalizeEmployee(e, parentResource);
          });

          const newEvents: SchedulerEvent[] = [];
          response.payload.forEach((e: any) => {
            if (e.EventsList && e.EventsList.length > 0) {
              e.EventsList.forEach((evt: any) => {
                newEvents.push(normalizeEvent(evt, String(e.AccountEmployeeId), 'task', e?.HoursPerDay));
              });
            }
          });

          setResources(prev =>
            prev.map(r => {
              if (r.id === projectId) {
                return {
                  ...r,
                  children: loadedEmployees
                };
              }
              return r;
            })
          );

          setEvents(prev => {
            const employeeIds = response.payload.map((e: any) => String(e.AccountEmployeeId));
            const filteredEvents = prev.filter(evt =>
              evt.types !== 'task' || !employeeIds.includes(evt.resourceId)
            );
            return [...filteredEvents, ...newEvents];
          });
        }
      } catch (err) {
        console.error("Failed to refresh project data", err);
      }
    }
  }, [dispatch, resources, refreshData, tabs, SelectedStartDate, SelectedEndDate]);

  // 3. Handle Date Changes
  const shiftDateRange = (type: "previous" | "next") => {
    const diff = type === "previous" ? -1 : 1;
    const start = new Date(SelectedStartDate);
    const end = new Date(SelectedEndDate);
    start.setMonth(start.getMonth() + diff);
    end.setMonth(end.getMonth() + diff);
    setSelectedStartDate(start);
    setSelectedEndDate(end);
    dispatch(UpdateSchedulerMonth(start));
    setTimeout(() => scrollToTop(), 100);
  };

  const handleDateRangeChange = (value: [Date | null, Date | null] | null) => {
    if (value && value[0] && value[1]) {
      const startDate = value[0];
      const endDate = value[1];
      const twoMonthsLater = addMonths(startDate, 2);
      const minAllowedEndDate = addMonths(startDate, 1);
      const maxAllowedEndDate = subDays(twoMonthsLater, 1);

      if (endDate < minAllowedEndDate) {
        ShowToast('Error', 'Please select a date range of maximum 2 months', "error", "toast-top-right");
        return;
      }

      if (endDate > maxAllowedEndDate) {
        ShowToast('Error', 'Please select a date range of maximum 2 months', "error", "toast-top-right");
        return;
      }

      setSelectedStartDate(value[0]);
      setSelectedEndDate(value[1]);
    }
  };

  const handleCloseModal = () => {
    dispatch(UpdateToShowModal(false));
  }

  const onClose = () => {
    dispatch(ShowAssignmentModal({ flag: false, ShowAssignmentModal: null }));
  }

  const onCloseMilestone = () => {
    dispatch(UpdateShowMilestone(false))
    setMilestoneClickedDate(null);
  }

  const OnCloseProjectModal = () => {
    dispatch(UpdateToShowProjectsModal(false))
  }

 const handleEventClick = async (event: SchedulerEvent) => {

    if (event.types === 'task') {
      const response = await fetchTimeliveAPI(`api/Scheduler/GetAccountEmployeeSchedulerById/${event?.ProjectId}/${event?.AccountProjectTaskId}/${event?.AccountEmployeeSchedulerId}`, 'GET', '', true);
      const result = await response.json();
      if (result.StatusCode == 200) {
        const data = result?.Data[0];
        const permissionForEdit = data?.ApplyAllProjectsForEdit ? data?.ApplyAllProjectsForEdit : data?.ApplyMyProjectsForEdit;
        if (!permissionForEdit) {
          ShowToast('Warning', "You do not have permission to schedule hours.", "warning", "toast-top-right");
          return;
        }
      }
      const filterResource = resources.find((item: any) => item?.id == event?.ProjectId);
      const employeeTask = filterResource?.children?.find((item: any) => item?.id == event?.resourceId);
      if (employeeTask) {
        dispatch(ShowAssignmentModal({
          flag: true,
          ShowAssignmentModal: {
            ...employeeTask,
            ...event,
            clickedDate: event.start,
          }
        }));
      }
    } else if (event.types === 'taskTeam') {
      const response = await fetchTimeliveAPI(`api/Scheduler/GetAccountEmployeeSchedulerById/${event?.ProjectId}/${event?.AccountProjectTaskId}/${event?.AccountEmployeeSchedulerId}`, 'GET', '', true);
      const result = await response.json();
      if (result.StatusCode == 200) {
        const data = result?.Data[0];
        const permissionForEdit = data?.ApplyAllProjectsForEdit ? data?.ApplyAllProjectsForEdit : data?.ApplyMyProjectsForEdit;
        if (!permissionForEdit) {
          ShowToast('Warning', "You do not have permission to schedule hours.", "warning", "toast-top-right");
          return;
        }
      }
      const filterResource = resources.find((item: any) => item?.id == event?.AccountEmployeeId);
      const projectTask = filterResource?.children?.find((item: any) => item?.id == event?.resourceId);

      if (projectTask) {
        dispatch(ShowAssignmentModal({
          flag: true,
          ShowAssignmentModal: {
            ...projectTask,
            ...event,
            employeeName: filterResource?.name,
            clickedDate: event.start,
          }
        }));
      }

    } else if (event.types === 'milestone') {
      if (!milestonePermission?.IsEdit) {
        ShowToast('Warning', "You do not have permission to edit this specific milestone.", "warning", "toast-top-right");
        return;
      }
      setMilestoneData(event);
      dispatch(UpdateShowMilestone(true));
    }
  };

  const handleUpdate = async (event: any) => {
    const startDate = new Date(event?.start);
    const endDate = new Date(event?.end);
    const day = countWorkingDays(startDate, endDate);
    const payload = {
      AccountId: AccountId,
      AccountProjectId: event?.ProjectId,
      AccountEmployeeId: tabs === 'team' ? event?.AccountEmployeeId : event?.resourceId,
      AccountProjectTaskId: event?.AccountProjectTaskId,
      AccountEmployeeSchedulerId: event?.AccountEmployeeSchedulerId,
      StartDate: moment(event?.start).format('YYYY-MM-DD'),
      EndDate: moment(event?.end).format('YYYY-MM-DD'),
      AllocationHours: event?.allocationHoursPerDay * day,
      AllocationHoursPerDay: event?.allocationHoursPerDay,
      ModifiedByEmployeeId: AccountEmployeeId
    }

    try {
      const response = await fetchTimeliveAPI(`api/Scheduler/UpdateAccountEmployeeScheduler/${event?.AccountEmployeeSchedulerId}`, 'PUT', payload, true)
      const result = await response.json();
      if (result?.StatusCode === '200') {
        refreshProjectData(event?.ProjectId);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getCapacityOptions = async () => {
    try {
      const response = await dispatch(GetEmployeeSchedulerCapacity());
      const options = response.payload.map((item: any) => ({
        label: item?.CapacityName,
        value: item?.SystemEmployeeSchedulerCapacityId
      }));
      setCapacityoptions(options);
      if (options.length > 0) {
        setSelectedCapacity(options[0])
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleLoadMore = useCallback(() => {
    if (loadingCounter > 0 || isFetchingRef.current || !isPermissionLoaded) return;

    if (activeTab === 'resource' && hasMoreProjects) {
      const nextPage = projectPageNo + 1;
      setProjectPageNo(nextPage);
      getProjectsAndClients(nextPage, true, search);
    } else if (activeTab === 'team' && hasMoreEmployees) {
      const nextPage = employeePageNo + 1;
      setEmployeePageNo(nextPage);
      getEmployeesForTeam(nextPage, true, search);
    }
  }, [activeTab, hasMoreProjects, hasMoreEmployees, loadingCounter, projectPageNo, employeePageNo, search, getProjectsAndClients, isPermissionLoaded]);

  useEffect(() => {
    getCapacityOptions();
  }, [tabs])

  const handleCapacityChange = async (selected: any) => {
    setSelectedCapacity(selected)
    const payload = {
      AccountId,
      AccountEmployeeId,
      SystemEmployeeSchedulerCapacityId: selected?.value,
      ModifiedByEmployeeId: AccountEmployeeId,
      ModifiedOn: moment().format('YYYY-MM-DD')
    }
    try {
      const response = await dispatch(UpdateEmployeeSchedulerCapacity(payload));
      if (response) {
        if (tabs === 'reasource') {
          getProjectsAndClients();
        } else {
          getEmployeesForTeam();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const customSelectStyles = {
    control: (base: any) => ({
      ...base,
      width: 150,
      minHeight: '35px',
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
    .custom-date-range-picker .rs-picker-toggle-value {
      white-space: nowrap !important;
      overflow: visible !important;
      text-overflow: unset !important;
      color: #172b4d !important;
     font-weight: 600 !important;
    }
    .custom-date-range-picker .rs-picker-toggle {
      width: auto !important;
      min-width: fit-content !important;
      padding-right: 8px !important;
      padding-left: 8px !important;
      padding-top: 6px !important;
      padding-bottom: 6px !important;
    }
    .custom-date-range-picker .rs-picker-toggle-caret {
      display: none !important;
    }
    .custom-date-range-picker .rs-picker-toggle,
    .custom-date-range-picker .rs-picker-toggle:focus,
    .custom-date-range-picker .rs-picker-toggle:active,
    .custom-date-range-picker .rs-picker-toggle:focus-visible {
      border-color: transparent !important;
      box-shadow: none !important;
      outline: none !important;
      background-color: transparent !important;
      color: #172b4d !important;
         font-weight: 600 !important;
    }
     .custom-date-range-picker .rs-picker-toggle-caret {
      display: none !important;
    }
    .custom-date-range-picker .rs-picker-toggle-clean {
      display: none !important;
    }
    .custom-date-range-picker {
    display: flex;
    align-items: center;
    }
  `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      {loadingCounter > 0 && <Loader />}

      <div className="p-4 d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="h3 fw-bold text-dark headerTitle mt-2">{getValueFromResource('Schedule', dispatch, t)}</h1>
            <div className="d-flex gap-1">
            <span
              className="schedule-icon-btn me-3 cursor-pointer"
              data-tooltip-id="scheduler-event-tooltip"
              data-tooltip-content="Scheduled vs Tracked hours report"
              data-tooltip-place="bottom"
              onClick={() => navigate('/assignedScheduleHours')}
            >
              <i className="ki-outline ki-graph-up fs-2 text-gray-600"></i>
            </span>
          <div className="d-flex align-items-center flex-shrink-0" style={{ position: 'relative', backgroundColor: 'white', border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '4px', height: '36px' }}>
            <a onClick={() => shiftDateRange("previous")} className="btn btn-sm btn-icon btn-icon-primary"><i className="ki-outline ki-left fs-3"></i></a>
            <DateRangePicker
              value={[SelectedStartDate, SelectedEndDate]}
              onChange={handleDateRangeChange}
              // ranges={DatePickerRanges()}
              ranges={[]}
              style={{ width: 'auto' }}
              className="custom-date-range-picker"
              appearance="subtle"
              placement="bottomEnd"
              format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
              editable={false}
              cleanable={false}
            />
            <a onClick={() => shiftDateRange("next")} className="btn btn-sm btn-icon btn-icon-primary"><i className="ki-outline ki-right fs-3"></i></a>
          </div>
            </div>
        </div>
        <div className="separator mt-3"></div>
        <div className="card card-custom admin-card">
          <div className='card-Report-body py-3'>
            <div className="d-flex justify-content-between align-items-center flex-wrap my-3">
              <ul className="nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-1 mb-0">
               {!showProjectTab && <li className="nav-item">
                  <a
                    className={clsx('nav-link cursor-pointer', {
                      active: activeTab === 'resource',
                    })}
                    onClick={() => {
                      dispatch(updateTabs('resource'));
                      setActiveTab('resource');
                      setSearch('');
                      setResources([]);
                      setEvents([]);
                    }}
                    style={{ fontWeight: 500 }}
                  >
                    {getValueFromResource('Project Schedule', dispatch, t)}
                  </a>
                </li>}

                <li className="nav-item">
                  <a
                    className={clsx('nav-link cursor-pointer', {
                      active: activeTab === 'team',
                    })}
                    onClick={() => {
                      dispatch(updateTabs('team'));
                      setActiveTab('team');
                      setSearch('');
                      setResources([]);
                      setEvents([]);
                    }}
                    style={{ fontWeight: 500 }}
                  >
                    {getValueFromResource('Team Schedule', dispatch, t)}
                  </a>
                </li>
              </ul>

              <div className="d-flex align-items-center gap-3">
                {activeTab === 'team' && (
                  <>
                    <label className="form-label fs-7 fw-bold mb-0">{getValueFromResource('Capacity', dispatch, t)}</label>

                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable
                      name="capacity"
                      onChange={handleCapacityChange}
                      options={capacityOptions}
                      value={selectedCapacity}
                      styles={{ ...dropDownActiveInActive, ...customSelectStyles }}
                      maxMenuHeight={maxMenuHeight}
                      menuPortalTarget={document.body}
                    />

                    <div className="bullet bg-secondary h-35px w-1px"></div>
                  </>
                )}

                <div className="position-relative">
                  <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder={activeTab === 'team' ? getValueFromResource('Search employees', dispatch, t) : getValueFromResource('Search projects', dispatch, t)}
                    className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                  />
                  <i
                    className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0"
                    style={{ marginRight: '10px' }}
                  >
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                </div>
              </div>
            </div>

            {/* <div className="separator my-2"></div> */}
            {(resources?.length > 0) ? (
              <div className="card shadow-sm" style={{ height: '60vh', display: 'flex', flexDirection: 'column' }}>
                <div className="card-body p-0 overflow-hidden h-100" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                  <Scheduler
                    resources={resources}
                    events={events}
                    viewMode="Month"
                    expandMode="single"
                    startDate={SelectedStartDate}
                    endDate={SelectedEndDate}
                    onResourceExpand={handleResourceExpand}
                    onEventClick={handleEventClick}
                    onEventUpdate={(e) => console.log("Event moved:", e)}
                    UpdateEventResize={handleUpdate}
                    onTimeOffClick={(e: any) => console.log(e, "TimeOff")}
                    onScrollBottom={handleLoadMore}
                    onMilestoneAdd={(date) => {
                      setMilestoneClickedDate(date);
                      setMilestoneData({});
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className=''>
                <p className='noDataFound'>
                  {/* {t('No Record Found')} */}
                  {getValueFromResource('No Record Found', dispatch, t)}
                </p>
              </div>
            )}
          </div>
        </div>
        {isOpenModal && <AddEmployeeModal onClose={handleCloseModal} />}
        {isOpenProjectModal && <AddProjectModal onClose={OnCloseProjectModal} />}
        {showAssignment && <AssignTask onClose={onClose} onTaskSaved={refreshProjectData} />}
        {showMilestone && <AddUpdateMilestoneModal onClose={onCloseMilestone} onMilestoneSaved={refreshProjectData} editMilestone={milestoneData} DateAndProject={milestoneClickedDate} />}
        {timeOffConfirmation.show && (
          <TimeOffConfirmationModal
            show={timeOffConfirmation.show}
            onClose={() => dispatch(CloseTimeOffConfirmationModal())}
            onConfirm={() => {
              const { resourceData, clickedDate } = timeOffConfirmation;
              if (resourceData) {
                if (resourceData.type === 'person') {
                  dispatch(ShowAssignmentModal({ flag: true, ShowAssignmentModal: { ...resourceData, clickedDate } }));
                } else if (resourceData.type === 'teamProject') {
                  const employeeName = resources?.find((item: any) => item?.id === resourceData?.parentId)?.name;
                  dispatch(ShowAssignmentModal({ flag: true, ShowAssignmentModal: { ...resourceData, employeeName, AccountEmployeeId: resourceData?.parentId, clickedDate } }));
                }
              }

              dispatch(CloseTimeOffConfirmationModal());
            }}
            timeOffDate={timeOffConfirmation.timeOffDate!}
            timeOffTypeName={timeOffConfirmation.timeOffTypeName}
            isWeekend={timeOffConfirmation.isWeekend}
          />
        )}
        <ReactTooltip
          id="scheduler-event-tooltip"
          place="top"
          style={{
            fontSize: '12px',
            fontWeight: 'normal',
            padding: '8px 12px',
            borderRadius: '6px',
            backgroundColor: '#1F2937',
            color: 'white',
            zIndex: 999999,
            maxWidth: '250px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
        />
      </div >
    </>
  );
}

export default SchedulerMain;